export const CAPTCHA_KEY = '6LcufVIaAAAAACRpFPF47LgpsWrCfxVmQE_ieTYL'
